import { userPoolWebClientId } from "../config"

const getCognitoAttrPrefix = () => {
  const ClientPrefix = `CognitoIdentityServiceProvider.${userPoolWebClientId}`;
  let lastUserkey = `${ClientPrefix}.LastAuthUser`;
  let lastAuthUserId = localStorage.getItem(lastUserkey);
  return `${ClientPrefix}.${lastAuthUserId}`;
}

export const authenticateToken = () => {
  let idTokenKey = `${getCognitoAttrPrefix()}.idToken`;
  let idToken = localStorage.getItem(idTokenKey);
  return idToken;
}

export const getAuthEmailFromToken = () => {
  let userDataKey = `${getCognitoAttrPrefix()}.userData`;
  let userData = localStorage.getItem(userDataKey);
  let attr = JSON.parse(userData).UserAttributes;
  for(let item of attr){
    if(item.Name === "email"){
      return item.Value;
    }
  }
}

/**
 * Returns the Cognito groups the current user belongs to.
 * Decoded from the cognito:groups claim in the stored ID token JWT.
 */
export const getUserGroups = () => {
  const idToken = authenticateToken();
  if (!idToken) return [];
  try {
    const payload = JSON.parse(atob(idToken.split('.')[1]));
    return payload['cognito:groups'] || [];
  } catch (e) {
    return [];
  }
}
